export const DEFAULT_FORMAT = 'HH:mm';
export const DEFAULT_VALUE = '00:00';
